export const THEME_IDS = {
  LIGHT: 'light',
} as const;
